import { useInView } from '../hooks';
import { CountUp } from './CountUp';
import { TESTIMONIALS } from '../data';

function StarRow() {
  return (
    <div className="tst-stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <polygon points="12 2 15 9 22 9.3 16.5 14 18 21 12 17.3 6 21 7.5 14 2 9.3 9 9" />
        </svg>
      ))}
    </div>
  );
}

export function SocialProof() {
  const [ref, inView] = useInView<HTMLDivElement>(0.3);

  return (
    <section className="py-24" id="proof">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="proof-band reveal" ref={ref}>
          <div className="proof-stats">
            <div className="proof-stat">
              <div className="v">
                <CountUp to={23} trigger={inView} suffix="%" className="accent" />
              </div>
              <div className="l">of abandoned carts recovered</div>
            </div>
            <div className="proof-stat">
              <div className="v">
                <CountUp to={-34} trigger={inView} suffix="%" />
              </div>
              <div className="l">COD return-to-origin rate</div>
            </div>
            <div className="proof-stat">
              <div className="v">
                <CountUp to={1.2} trigger={inView} decimals={1} suffix="s" />
              </div>
              <div className="l">average answer time, inbound</div>
            </div>
            <div className="proof-stat">
              <div className="v"><span>24/7</span></div>
              <div className="l">always-on voice coverage</div>
            </div>
          </div>
        </div>

        <div className="tst-grid reveal reveal-stagger">
          {TESTIMONIALS.map((t) => (
            <div className="tst-card" key={t.name}>
              <StarRow />
              <p className="tst-quote">"{t.quote}"</p>
              <div className="tst-author">
                <div className="tst-avatar" style={{ background: t.bg }}>{t.initial}</div>
                <div>
                  <div className="n">{t.name}</div>
                  <div className="r">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
